import { MSEnum } from '@/common/enumeration';

export default {};
